import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@material-ui/core'
import React, { FC } from 'react'
import styled, { css } from 'styled-components'

import GlobalLink, { LinkProps as GlobalLinkProps } from '../../../global/Link'

const linkStyles = css`
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.global.smallHeaders};
  font-weight: 500;
  letter-spacing: 0.06em;
  text-decoration: underline;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.text.primary};
  padding: 0;
  height: fit-content;

  &:hover {
    background-color: transparent;
  }
`
const Link = styled(GlobalLink)`
  ${linkStyles};
`
const Button = styled(MuiButton)`
  ${linkStyles};
`

export const RewardsLink: FC<GlobalLinkProps> = ({ children, ...props }) => {
  return <Link {...props}>{children}</Link>
}

export const RewardsLinkButton: FC<MuiButtonProps> = ({ children, ...props }) => {
  return <Button {...props}>{children}</Button>
}
